export interface StaticMenuItem {
  key: string;
  label: string;
  icon?: string;
  path?: string;
  children?: StaticMenuItem[];
}

export const staticMenuConfig: StaticMenuItem[] = [
  {
    key: '/dashboard',
    label: '工作台',
    icon: 'DashboardOutlined',
    path: '/dashboard',
  },
  {
    key: '/provider-dashboard',
    label: '代理商工作台',
    icon: 'ShopOutlined',
    path: '/provider-dashboard',
  },
  {
    key: 'menu-system',
    label: '系统管理',
    icon: 'SettingOutlined',
    children: [
      {
        key: '/user-management',
        label: '用户管理',
        icon: 'UserOutlined',
        path: '/user-management',
      },
      {
        key: '/role-management',
        label: '角色管理',
        icon: 'TeamOutlined',
        path: '/role-management',
      },
      {
        key: '/menu-management',
        label: '菜单管理',
        icon: 'MenuOutlined',
        path: '/menu-management',
      },
      {
        key: '/dict-management',
        label: '字典管理',
        icon: 'BookOutlined',
        path: '/dict-management',
      },
      {
        key: '/region-management',
        label: '地区管理',
        icon: 'ApartmentOutlined',
        path: '/region-management',
      },
      {
        key: '/system/service-provider-management',
        label: '代理商管理',
        icon: 'TeamOutlined',
        path: '/system/service-provider-management',
      },
      {
        key: '/system/my-info',
        label: '我的信息',
        icon: 'IdcardOutlined',
        path: '/system/my-info',
      },
      {
        key: '/system/provider-settlement-flows',
        label: '代理商结算流水',
        icon: 'WalletOutlined',
        path: '/system/provider-settlement-flows',
      },
      {
        key: '/system/provider-income-flows',
        label: '代理商收入流水',
        icon: 'FundOutlined',
        path: '/system/provider-income-flows',
      },
      {
        key: '/redis-monitor',
        label: 'Redis 监控',
        icon: 'DatabaseOutlined',
        path: '/redis-monitor',
      },
      {
        key: 'menu-mini-program',
        label: '小程序管理',
        icon: 'AppstoreOutlined',
        children: [
          {
            key: '/mini-program/user-config',
            label: '用户小程序配置',
            icon: 'UserOutlined',
            path: '/mini-program/user-config',
          },
          {
            key: '/mini-program/staff-config',
            label: '服务人员小程序配置',
            icon: 'TeamOutlined',
            path: '/mini-program/staff-config',
          },
        ],
      },
      {
        key: 'menu-system-settings',
        label: '系统设置',
        icon: 'SettingOutlined',
        path: '/system-settings',
      },
      {
        key: '/system/meituan-inventory-config',
        label: '美团库存配置',
        icon: 'ClockCircleOutlined',
        path: '/system/meituan-inventory-config',
      },
      {
        key: '/system/meituan-financial-health',
        label: '美团同步健康',
        icon: 'SafetyOutlined',
        path: '/system/meituan-financial-health',
      },
      {
        key: '/meituan/config',
        label: '美团配置',
        icon: 'ApiOutlined',
        path: '/meituan/config',
      },
      {
        key: '/meituan/shops',
        label: '美团门店管理',
        icon: 'ShopOutlined',
        path: '/meituan/shops',
      },
      {
        key: '/meituan/order-confirm-logs',
        label: '美团接单日志',
        icon: 'FileSearchOutlined',
        path: '/meituan/order-confirm-logs',
      },
      {
        key: '/meituan/order-fulfill-logs',
        label: '美团履约日志',
        icon: 'FileSearchOutlined',
        path: '/meituan/order-fulfill-logs',
      },
      {
        key: '/meituan/reservation-change-logs',
        label: '美团改约日志',
        icon: 'FileSearchOutlined',
        path: '/meituan/reservation-change-logs',
      },
      {
        key: '/meituan/reservation-order-logs',
        label: '美团预约订单日志',
        icon: 'FileSearchOutlined',
        path: '/meituan/reservation-order-logs',
      },
      {
        key: '/meituan/cancel-logs',
        label: '美团取消日志',
        icon: 'FileSearchOutlined',
        path: '/meituan/cancel-logs',
      },
      {
        key: '/scheduled/notification-config',
        label: '定时任务',
        icon: 'ClockCircleOutlined',
        path: '/scheduled/notification-config',
      },
    ],
  },
  {
    key: 'menu-service-project',
    label: '服务项目管理',
    icon: 'AppstoreOutlined',
    children: [
      {
        key: '/service/category',
        label: '服务分类',
        icon: 'AppstoreOutlined',
        path: '/service/category',
      },
      {
        key: '/service/product',
        label: '服务产品',
        icon: 'ProfileOutlined',
        path: '/service/product',
      },
      {
        key: '/service/coupon',
        label: '优惠券',
        icon: 'WalletOutlined',
        path: '/service/coupon',
      },
      {
        key: '/service/time',
        label: '服务时间管理',
        icon: 'ClockCircleOutlined',
        path: '/service/time',
      },
    ],
  },
  {
    key: 'menu-staff-management',
    label: '服务人员管理',
    icon: 'TeamOutlined',
    children: [
      {
        key: '/staff/certification-review',
        label: '认证审核',
        icon: 'SafetyOutlined',
        path: '/staff/certification-review',
      },
      {
        key: '/staff/management',
        label: '服务人员',
        icon: 'UserOutlined',
        path: '/staff/management',
      },
      {
        key: '/staff/service-process',
        label: '服务过程管理',
        icon: 'ProfileOutlined',
        path: '/staff/service-process',
      },
      {
        key: '/staff/training',
        label: '服务培训',
        icon: 'BookOutlined',
        path: '/staff/training',
      },
      {
        key: '/staff/auto-dispatch-config',
        label: '自动派单配置',
        icon: 'SettingOutlined',
        path: '/staff/auto-dispatch-config',
      },
      {
        key: '/staff/withdraw-review',
        label: '提现审核',
        icon: 'WalletOutlined',
        path: '/staff/withdraw-review',
      },
      {
        key: '/staff/deposit-payment',
        label: '保证金支付流水',
        icon: 'WalletOutlined',
        path: '/staff/deposit-payment',
      },
      {
        key: '/staff/deposit-refund-request',
        label: '保证金提现申请',
        icon: 'WalletOutlined',
        path: '/staff/deposit-refund-request',
      },
      {
        key: '/staff/withdraw-rule',
        label: '服务人员提现规则',
        icon: 'SettingOutlined',
        path: '/staff/withdraw-rule',
      },
    ],
  },
  {
    key: 'menu-order-management',
    label: '订单管理',
    icon: 'SafetyOutlined',
    children: [
      {
        key: '/payment/order',
        label: '订单管理',
        icon: 'ProfileOutlined',
        path: '/payment/order',
      },
      {
        key: '/payment/order-pool',
        label: '订单池管理',
        icon: 'InboxOutlined',
        path: '/payment/order-pool',
      },
      {
        key: '/payment/app',
        label: '用户支付配置',
        icon: 'WalletOutlined',
        path: '/payment/app',
      },
      {
        key: '/payment/refund',
        label: '退款申请',
        icon: 'FileTextOutlined',
        path: '/payment/refund',
      },
      {
        key: '/payment/notify',
        label: '订单支付记录',
        icon: 'BellOutlined',
        path: '/payment/notify',
      },
    ],
  },
  {
    key: 'menu-finance-management',
    label: '财务管理',
    icon: 'WalletOutlined',
    children: [
      {
        key: '/finance/report/overview',
        label: '财务报表',
        icon: 'FundOutlined',
        path: '/finance/report/overview',
      },
    ],
  },
  {
    key: 'menu-logs',
    label: '日志管理',
    icon: 'FileTextOutlined',
    children: [
      {
        key: '/logs/login',
        label: '登录日志',
        icon: 'ProfileOutlined',
        path: '/logs/login',
      },
      {
        key: '/logs/operation',
        label: '操作日志',
        icon: 'FileSearchOutlined',
        path: '/logs/operation',
      },
      {
        key: '/logs/meituan-verify',
        label: '验券日志',
        icon: 'FileSearchOutlined',
        path: '/logs/meituan-verify',
      },
    ],
  },
  {
    key: 'menu-files',
    label: '文件管理',
    icon: 'FolderOutlined',
    children: [
      {
        key: '/files/config',
        label: '文件配置',
        icon: 'SettingOutlined',
        path: '/files/config',
      },
      {
        key: '/files/management',
        label: '文件列表',
        icon: 'FileOutlined',
        path: '/files/management',
      },
    ],
  },
  {
    key: 'menu-sms',
    label: '短信管理',
    icon: 'BellOutlined',
    children: [
      {
        key: '/sms/channel',
        label: '短信渠道',
        icon: 'CloudOutlined',
        path: '/sms/channel',
      },
      {
        key: '/sms/template',
        label: '短信模板',
        icon: 'FileTextOutlined',
        path: '/sms/template',
      },
      {
        key: '/sms/log',
        label: '短信日志',
        icon: 'ProfileOutlined',
        path: '/sms/log',
      },
    ],
  },
  {
    key: 'menu-scheduled',
    label: '通知任务',
    icon: 'BellOutlined',
    children: [
      {
        key: '/scheduled/notification-log',
        label: '通知日志',
        icon: 'ProfileOutlined',
        path: '/scheduled/notification-log',
      },
    ],
  },
  {
    key: 'menu-member',
    label: '会员管理',
    icon: 'UserOutlined',
    children: [
      {
        key: '/member-management',
        label: '会员总览',
        icon: 'UserOutlined',
        path: '/member-management',
      },
      {
        key: '/member/list',
        label: '会员列表',
        icon: 'TeamOutlined',
        path: '/member/list',
      },
      {
        key: '/member/recharge',
        label: '会员充值',
        icon: 'ExportOutlined',
        path: '/member/recharge',
      },
      {
        key: '/member/wallet',
        label: '会员钱包',
        icon: 'DatabaseOutlined',
        path: '/member/wallet',
      },
    ],
  },
  {
    key: 'menu-workflow',
    label: '工作流',
    icon: 'ApartmentOutlined',
    children: [
      {
        key: '/workflow/todo',
        label: '待办任务',
        icon: 'ProfileOutlined',
        path: '/workflow/todo',
      },
      {
        key: '/workflow/done',
        label: '已办任务',
        icon: 'FileTextOutlined',
        path: '/workflow/done',
      },
      {
        key: '/workflow/initiated',
        label: '我发起的',
        icon: 'UserOutlined',
        path: '/workflow/initiated',
      },
      {
        key: '/workflow/cc',
        label: '抄送我的',
        icon: 'BellOutlined',
        path: '/workflow/cc',
      },
      {
        key: '/workflow/start',
        label: '发起流程',
        icon: 'ExportOutlined',
        path: '/workflow/start',
      },
      {
        key: '/workflow/definitions',
        label: '流程定义',
        icon: 'MenuOutlined',
        path: '/workflow/definitions',
      },
      {
        key: '/workflow/delegates',
        label: '委托设置',
        icon: 'TeamOutlined',
        path: '/workflow/delegates',
      },
      {
        key: '/workflow/form-designer',
        label: '表单设计',
        icon: 'AppstoreOutlined',
        path: '/workflow/form-designer',
      },
    ],
  },
];
